<template>
    <div>
        <equipmentList :game_id="game_id"></equipmentList>
    </div>
</template>

<script>

import equipmentList from '@/components/games/equipment/list.vue';

export default {
    components: {
        equipmentList
    },
    data () {
        let self = (window.x = this)
        return {
            game_id: 1,
        }
    },
    methods: {
    },
    mounted () {
    },
    watch: {},
    computed: {}
}
</script>